<template>
  <div>
    {{ $t('auth.register.success') }}

    <validate-form-button
      @click="resendConfirmationCode"
      :isLoading="isLoading"
      :label="'auth.register.resendConfirmationCode'"
    />
    <span v-if="success">{{ $t('auth.resendConfirmationCodeSuccess') }}</span>
    <span v-if="error">{{ $t(error) }}</span>
  </div>
</template>

<script>
import ValidateFormButton from '@/components/common/ValidateFormButton'
import { RESEND_CONFIRMATION_CODE } from '@/store/modules/user/types'

export default {
  name: 'ConfirmRegistration',
  components: {
    ValidateFormButton
  },
  data: () => ({
    isLoading: false,
    success: false,
    error: false
  }),
  computed: {
    registeringUser() {
      return this.$store.state.user.registeringUser
    }
  },
  methods: {
    async resendConfirmationCode() {
      this.isLoading = true
      this.error = false
      this.success = false

      const [error, response] = await this.$store.dispatch(RESEND_CONFIRMATION_CODE)


      if (error || response.data.error) {
        if (error && error.code) {
          this.error = error.code
        } else if (response.data.error) {
          this.error = response.data.reason
        } else {
          this.error = 'custom/internal-error'
        }
      } else {
        this.success = true
        this.isLoading = false
      }

      this.isLoading = false
    }
  },
  mounted() {
    if (!this.registeringUser) {
      this.$router.push('Home')
    }
  }
}
</script>
